import React from 'react'
import { Events } from '../Data/Events'
import { Link, useParams } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'
import { Icon } from 'semantic-ui-react'

export default function EventDetails() {
  const { id } = useParams()
  const mobile = useMediaQuery({ query: '(max-width:1150px)' })

  const eventItem = Events.find(e => String(e.id) === String(id))

  if (!eventItem) {
    return (
      <>
        <div
          className='pageBanner'
          style={{ height: `${mobile ? '65px' : '90px'}`, backgroundColor: '#171717' }}
        />
        <div className='newsDetailsWrapper' style={{ textAlign: 'center', padding: '60px 20px' }}>
          <h2>Event Not Found</h2>
          <br />
          <Link to='/events' className='newsBackLink'>
            <Icon name='arrow left' /> Back to Events
          </Link>
        </div>
      </>
    )
  }

  const isUpcoming = eventItem.sort ? new Date(eventItem.sort) >= new Date() : false

  return (
    <>
      <div
        className='pageBanner'
        style={{ height: `${mobile ? '65px' : '90px'}`, backgroundColor: '#171717' }}
      />

      <article className='newsDetailsWrapper'>
        <Link to='/events' className='newsBackLink'>
          <Icon name='arrow left' /> Back to Events
        </Link>

        <div className='newsMeta eventMetaContainer'>
          {eventItem.date && (
            <span className='eventMetaBadge'>
              <Icon name='calendar alternate outline' /> {eventItem.date}
            </span>
          )}
          {eventItem.time && eventItem.time !== 'TBA' && (
            <span className='eventMetaBadge'>
              <Icon name='clock outline' /> {eventItem.time}
            </span>
          )}
          {eventItem.location && eventItem.location !== 'TBA' && (
            eventItem.map ? (
              <a
                href={eventItem.map}
                target='_blank'
                rel='noreferrer'
                className='eventMetaBadge eventMapLink'
                title='Open in Google Maps'
              >
                <Icon name='map marker alternate' /> {eventItem.location}
              </a>
            ) : (
              <span className='eventMetaBadge'>
                <Icon name='map marker alternate' /> {eventItem.location}
              </span>
            )
          )}
        </div>

        <h1 className='newsHeadline'>{eventItem.event}</h1>

        {eventItem.image && (
          <div className='newsHeroImageContainer'>
            <img
              src={eventItem.image}
              alt={eventItem.event}
              className='newsHeroImage'
            />
          </div>
        )}

        {eventItem.summary && (
          <div className='newsBody'>
            {typeof eventItem.summary === 'string' ? (
              <p>{eventItem.summary}</p>
            ) : (
              eventItem.summary
            )}
          </div>
        )}

        {(eventItem.form || eventItem.gallery || eventItem.flyer) && (
          <div className='eventActionButtons'>
            {eventItem.form && isUpcoming && (
              <a
                href={eventItem.form}
                target='_blank'
                rel='noreferrer'
                className='eventPrimaryBtn'
              >
                <Icon name='signup' /> Register / Sign Up
              </a>
            )}

            {eventItem.gallery && (
              <Link to={`/eventgallery/${eventItem.id}`} className='eventSecondaryBtn'>
                <Icon name='images outline' /> View Event Gallery
              </Link>
            )}

            {eventItem.flyer && (
              <a
                href={eventItem.flyer}
                target='_blank'
                rel='noreferrer'
                className='eventSecondaryBtn'
              >
                <Icon name='file image outline' /> View Event Flyer
              </a>
            )}
          </div>
        )}

        <div className='newsFooter'>
          <Link to='/events' className='newsFooterBackBtn'>
            <Icon name='arrow left' /> Back to All Events
          </Link>
        </div>
      </article>
    </>
  )
}
